module.exports = __webpack_public_path__ + "static/media/cloud_infrastructure.23c0a32e.svg";